import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Alert, Modal, ModalBody, ModalHeader, Spinner } from 'reactstrap';
import * as app_consts from "../../../utils/app_consts";
import { TENANT_CREATE_PROMOTION_API, TENANT_RETRIEVE_CREATE_PROMOTION_DATA_API } from '../../../api/api_data';
import { tenant_auth_actions_helper } from '../../../actions/actions_helper';
import { fail_retrieve_create_promotion_data, loading_retrieve_create_promotion_data, reset_retrieve_create_promotion_data, success_retrieve_create_promotion_data } from '../../../reducers/auth_tenant/retrieve_create_promotion_data_Slice';
import { COULD_NOT_RETRIEVE_DATA_ERROR_MSG, COULD_NOT_RETRIEVE_DATA_SUCCESS_MSG, CREATE_PROMOTION_ERROR_MSG, CREATE_PROMOTION_SUCCESS_MSG } from '../../../utils/error_success_messages';
import { useSelector } from 'react-redux';
import { getSelectedOption, messageToast } from '../../../utils/Utils';
import { Button, Col, Icon, Row, RSelect } from '../../Component';
import TextInput from '../../../pages/components/inputs/TextInput';
import { fail_create_promotion, loading_create_promotion, reset_create_promotion, success_create_promotion } from '../../../reducers/auth_tenant/create_promotion_Slice';

const initialState = { name: "", start_date: "", end_date: "", description: "", type: "", ussd_code: "" };

const CreatePromotionModal = ({ tenant_info, user_info, isOpen, successFunction, closeModal, data }) => {

  const [open, setOpen] = useState(isOpen);
  const [page_data, setPageData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const dispatch = useDispatch();
  const [sent_data, setSentData] = useState(data);
  const [submit_loading, setSubmitLoading] = useState(false);
  const [submit_error, setSubmitError] = useState("");
  const [formData, setFormData] = useState(initialState);

  useEffect(() => {
    setError("");
    setSubmitError("");
    setSentData(data);
    setOpen(isOpen);
    if (isOpen)
    {
      retrieve_data();
    }
  }, [isOpen, data]);

  const retrieve_data = () => {
    setError("");
    setSubmitError("");
    // Dispatch
    dispatch(tenant_auth_actions_helper(loading_retrieve_create_promotion_data, success_retrieve_create_promotion_data, fail_retrieve_create_promotion_data, COULD_NOT_RETRIEVE_DATA_ERROR_MSG, COULD_NOT_RETRIEVE_DATA_SUCCESS_MSG, app_consts.GET, `/${tenant_info?.url_prefix}/${TENANT_RETRIEVE_CREATE_PROMOTION_DATA_API}`));
  };
  // Listener
  const retrieve_create_promotion_data_listener = useSelector((state) => state.retrieve_create_promotion_data.retrieve_create_promotion_data);

  useEffect(() => {
    if (retrieve_create_promotion_data_listener.status !== app_consts.IDLE)
    {
      if (retrieve_create_promotion_data_listener.status === app_consts.LOADING)
      {
        setLoading(true);
        setError("");
      } else
      {
        setLoading(false);
        if (retrieve_create_promotion_data_listener.status === app_consts.FAIL)
        {
          messageToast(retrieve_create_promotion_data_listener.message, app_consts.FAIL);
          setError(retrieve_create_promotion_data_listener.message);
        } else if (retrieve_create_promotion_data_listener.status === app_consts.SUCCESS)
        {
          setPageData(retrieve_create_promotion_data_listener.data);
        }
        dispatch(reset_retrieve_create_promotion_data());
      }
    }
  }, [retrieve_create_promotion_data_listener]);



  // Handle Change Function
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleCreatePromotions = () => {
    setSubmitError("");
    // Dispatch
    const offsetMinutes = new Date().getTimezoneOffset();
    const offsetHours = Math.abs(offsetMinutes) / 60;
    const offsetSign = offsetMinutes > 0 ? "-" : "+";
    const formattedOffset = `${offsetSign}${String(offsetHours).padStart(2, "0")}:00`;

    const req_data = { ...formData, start_date: `${formData?.start_date}${formattedOffset}`, end_date: `${formData?.end_date}${formattedOffset}` };

    dispatch(tenant_auth_actions_helper(loading_create_promotion, success_create_promotion, fail_create_promotion, CREATE_PROMOTION_ERROR_MSG, CREATE_PROMOTION_SUCCESS_MSG, app_consts.POST, `/${tenant_info?.url_prefix}/${TENANT_CREATE_PROMOTION_API}`, req_data));
  };
  // Listener
  const create_promotion_listener = useSelector((state) => state.create_promotion.create_promotion);

  useEffect(() => {
    if (create_promotion_listener.status !== app_consts.IDLE)
    {
      if (create_promotion_listener.status === app_consts.LOADING)
      {
        setSubmitLoading(true);
        setSubmitError("");
      } else
      {
        setSubmitLoading(false);
        if (create_promotion_listener.status === app_consts.FAIL)
        {
          messageToast(create_promotion_listener.message, app_consts.FAIL);
          setSubmitError(create_promotion_listener.message);
        } else if (create_promotion_listener.status === app_consts.SUCCESS)
        {
          messageToast(CREATE_PROMOTION_SUCCESS_MSG, app_consts.SUCCESS);
          setPageData(create_promotion_listener.data);
        }
        dispatch(reset_create_promotion());
      }
    }
  }, [create_promotion_listener]);

  return (
    <>
      <Modal isOpen={open} toggle={submit_loading || loading ? "" : closeModal} className="modal-dialog-centered" size={"md "}>
        <ModalHeader toggle={submit_loading || loading ? "" : closeModal}>Create Promotion</ModalHeader>
        <ModalBody>
          {
            loading ?
              <>
                <div className="w-70 m-auto d-flex flex-column justify-content-center align-center" style={{ height: "200px" }} >
                  <div className="text-soft fw-bold" style={{ fontSize: 24, marginTop: "90px" }}>Retrieveing Data...</div>
                  <div className="nk-loader mt-2  w-70 m-auto "></div>
                </div>
              </>
              :
              <>
                {
                  error ?
                    <>
                      <div className="w-70 m-auto d-flex flex-column justify-content-center align-center" style={{ height: "200px" }} >
                        <div className="text-soft fw-bold" style={{ fontSize: 16, marginTop: "90px" }}>{error}</div>
                      </div>
                    </>
                    :
                    <>
                      <Row className="g-4">
                        <TextInput
                          label="Name"
                          type="name"
                          id_val="name"
                          value={formData?.name}
                          colSize="6"
                          required
                          name="name"
                          handleChange={handleChange}
                        />
                        <TextInput
                          label="Description"
                          type="description"
                          id_val="description"
                          value={formData?.description}
                          colSize="6"
                          required
                          name="description"
                          handleChange={handleChange}
                        />
                        <Col lg={6}>
                          <div className="form-group">
                            <label className="form-label mb-1 text-md" htmlFor="retrunable">
                              Start Date<span className='text-danger pr-2'>{` *`}</span>
                            </label>
                            <div className="w-100">

                              <input
                                type="datetime-local"
                                name="start_date"
                                value={formData?.start_date}
                                className="form-control"
                                min={new Date().toISOString().slice(0, 16)}
                                onChange={(e) => setFormData({ ...formData, start_date: e.target.value })}
                              />
                            </div>
                          </div>
                        </Col>
                        <Col lg={6}>
                          <div className="form-group">
                            <label className="form-label mb-1 text-md" htmlFor="retrunable">
                              End Date<span className='text-danger pr-2'>{` *`}</span>
                            </label>
                            <div className="w-100">

                              <input
                                type="datetime-local"
                                name="pre_auction_start_date"
                                value={formData?.end_date}
                                className="form-control"
                                min={formData?.start_date}
                                onChange={(e) => setFormData({ ...formData, end_date: e.target.value })}
                                disabled={!formData?.start_date}
                              />
                            </div>
                          </div>
                        </Col>
                        <Col size={6}>
                          <div className="form-group">
                            <label className="form-label mb-1 text-md" htmlFor="ussd_code">
                              Type<span className='text-danger pr-2'>{` *`}</span>
                            </label>
                            <div className="w-100">
                              <RSelect
                                options={page_data?.promotion_types}
                                className="w-100"
                                placeholder="Search"
                                id="ussd_code"
                                onChange={(e) => {
                                  setFormData({ ...formData, type: e.value });
                                }}
                                value={getSelectedOption(formData?.type, page_data?.promotion_types)}
                              />
                            </div>
                          </div>
                        </Col>
                        {
                          formData?.type === app_consts.USSD && (
                            <>
                              <Col size={6}>
                                <div className="form-group">
                                  <label className="form-label mb-1 text-md" htmlFor="ussd_code">
                                    USSD Code<span className='text-danger pr-2'>{` *`}</span>
                                  </label>
                                  <div className="w-100">
                                    <RSelect
                                      options={page_data?.ussd_codes}
                                      className="w-100"
                                      placeholder="Search"
                                      id="ussd_code"
                                      onChange={(e) => {
                                        setFormData({ ...formData, ussd_code: e.value });
                                      }}
                                      value={getSelectedOption(formData?.ussd_code, page_data?.ussd_codes)}
                                    />
                                  </div>
                                </div>
                              </Col>
                            </>
                          )
                        }
                        {submit_error && (
                          <div className="mb-3 w-100">
                            <Alert color="danger" className="alert-icon">
                              <Icon name="alert-circle" /> {submit_error}{" "}
                            </Alert>
                          </div>
                        )}
                        <Col xl="12" className="d-flex justify-content-end mt-2 mr-2">
                          <Button onClick={handleCreatePromotions} disabled={submit_loading || !(formData?.name && formData?.description && formData?.start_date && formData?.end_date && formData?.type && (formData?.type === app_consts.USSD ? formData?.ussd_code : true))} color="primary">
                            {submit_loading ? <Spinner size="sm" color="light" /> : "Create Promotion"}
                          </Button>
                        </Col>
                      </Row>
                    </>
                }
              </>
          }
        </ModalBody>
      </Modal>
    </>
  );
};

export default CreatePromotionModal;